// 9fbef606107a605d69c0edbcd8029e5d
import { RESET_PASSWORD_ACTION_PATTERN } from '../../../../constants/reducer.constants';

export default {
  RESET_PASSWORD: `${RESET_PASSWORD_ACTION_PATTERN}RESET_PASSWORD`,
  RESET_PASSWORD_SUCCESS: `${RESET_PASSWORD_ACTION_PATTERN}RESET_PASSWORD_SUCCESS`,
  RESET_PASSWORD_ERROR: `${RESET_PASSWORD_ACTION_PATTERN}RESET_PASSWORD_ERROR`,
  RESET_STATE: `${RESET_PASSWORD_ACTION_PATTERN}RESET_STATE`,
  RESET_PASSWORD_SUBMIT_START: `${RESET_PASSWORD_ACTION_PATTERN}RESET_PASSWORD_SUBMIT_START`,
  RESET_PASSWORD_SUBMIT_STOP: `${RESET_PASSWORD_ACTION_PATTERN}RESET_PASSWORD_SUBMIT_STOP`,
  SUBMIT_OTP: `${RESET_PASSWORD_ACTION_PATTERN}SUBMIT_OTP`,
  OTP_LENGTH: 6,
  FETCH_PHONE_LOOKUP: `${RESET_PASSWORD_ACTION_PATTERN}FETCH_PHONE_LOOKUP`,
  RESET_PASSWORD_PHONE_COUNTRY_CODE: `${RESET_PASSWORD_ACTION_PATTERN}RESET_PASSWORD_PHONE_COUNTRY_CODE`,
};
